import { CrossCircleIcon, InfoIcon, LightbulbIcon, TickCircleIcon, WarningIcon } from '../Icons';
export const resolveInfoBoxIcon = ({ icon, variant }) => {
    switch (variant) {
        case 'error':
            return CrossCircleIcon;
        case 'info':
            return InfoIcon;
        case 'warning':
            return WarningIcon;
        case 'success':
            return TickCircleIcon;
        default:
            return icon ?? LightbulbIcon;
    }
};
export const resolveFontVariant = (heading, size) => {
    if (size === 'small') {
        return heading ? 'small--heading7' : 'small--small';
    }
    return heading ? 'small--heading6' : 'small--regular';
};
